var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58301 9.09595C4.58301 13.5434 8.47378 17.2213 10.1959 18.6314C10.4424 18.8333 10.5671 18.9354 10.751 18.9871C10.8942 19.0274 11.1049 19.0274 11.2481 18.9871C11.4323 18.9353 11.5562 18.8342 11.8035 18.6316C13.5257 17.2215 17.4163 13.5439 17.4163 9.09636C17.4163 7.41325 16.7403 5.79888 15.5369 4.60875C14.3335 3.41861 12.7016 2.75 10.9997 2.75C9.29794 2.75 7.66576 3.41871 6.46241 4.60885C5.25905 5.79898 4.58301 7.41284 4.58301 9.09595Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 8.25C9.16634 9.26252 9.98715 10.0833 10.9997 10.0833C12.0122 10.0833 12.833 9.26252 12.833 8.25C12.833 7.23748 12.0122 6.41667 10.9997 6.41667C9.98715 6.41667 9.16634 7.23748 9.16634 8.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.61f7891ea0a5901357c39f629a6fd8b9.svg";
export { ForwardRef as ReactComponent };